import AdminHotelEditImages from './admin-hotel-edit-images-component';

import './admin-hotel-edit-images.scss';

const MODULE_NAME = 'app.admin.hotel-edit.images';
const module = angular
    .module(MODULE_NAME, [])
    .directive(AdminHotelEditImages.DIRECTIVE_NAME, AdminHotelEditImages);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-edit/admin-hotel-edit-images/admin-hotel-edit-images-module.js